import { useClubItem } from "@/api/club/useClub";
import { useMyOrganizations } from "@/api/organizations/useMyOrganizations";
import { useNetworkStatus } from "@/network/NetworkContext";
import { useTheme } from "@/theme/ThemeProvider";
import { useStyles } from "@/theme/styles";
import { ClubItemDetail } from "@/ui/components/club/ClubItemDetail";
import { Screen } from "@/ui/components/Screen";
import { ErrorState, LoadingState } from "@/ui/components/StateViews";
import { useLocalSearchParams } from "expo-router";
import React from "react";
import { Text } from "react-native";

export default function ClubItemScreen() {
  const { theme } = useTheme();
  const s = useStyles();
  const { isOnline } = useNetworkStatus();
  const params = useLocalSearchParams<{ itemId: string }>();
  const itemId = params.itemId;
  const { organizations, memberships } = useMyOrganizations();
  const org = organizations[0];
  const roles =
    memberships.find((m) => m.organization_id === org?.id)?.roles ?? [];
  const canManageOfficial = roles.some((r) =>
    ["board", "admin"].includes(r)
  );
  const canManageEvent = roles.some((r) =>
    ["organizer", "board", "admin"].includes(r)
  );

  const { item, loading, error, refetch } = useClubItem(
    itemId,
    isOnline && !!itemId
  );

  if (!isOnline) {
    return (
      <Screen title="Beitrag">
        <Text style={s.textBody}>
          Der Vereinsbereich benötigt eine Internetverbindung.
        </Text>
      </Screen>
    );
  }

  if (loading && !item) {
    return (
      <Screen title="Beitrag">
        <LoadingState />
      </Screen>
    );
  }

  if (error || !item) {
    return (
      <Screen title="Beitrag">
        <ErrorState
          message={(error as Error)?.message ?? "Eintrag nicht gefunden"}
          onRetry={() => void refetch()}
        />
      </Screen>
    );
  }

  return (
    <Screen
      title={
        item.item_type === "poll"
          ? "Umfrage"
          : item.item_type === "event"
            ? "Veranstaltung"
            : "Beitrag"
      }
      scroll
      contentStyle={{ paddingBottom: theme.space.xxl }}
    >
      <ClubItemDetail
        item={item}
        organizationId={org?.id ?? item.organization_id}
        canManageOfficial={canManageOfficial}
        canManageEvent={canManageEvent}
        disabled={!isOnline}
      />
    </Screen>
  );
}
